import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import engageImg from './img/engage-img.avif';
import css from './AudiencePage.module.css';

const listItem = (titleMsgId, textMsgId) => (
  <li className={css.engageListItem}>
    <h3 className={css.engageListItemTitle}>
      <FormattedMessage id={titleMsgId} />
    </h3>
    <p className={css.engageListItemText}>
      <FormattedMessage id={textMsgId} />
    </p>
  </li>
);

const SectionEngage = () => {
  return (
    <div className={css.sectionEngage}>
      <h2 className={css.engageTitle}>
        <FormattedMessage id="AudiencePage.engageTitle" />
      </h2>
      <div className={css.engageContent}>
        <img className={css.engageImg} alt="Engage" src={engageImg} />
        <ul className={css.engageList}>
          {listItem('AudiencePage.engageFirstLineTitle', 'AudiencePage.engageFirstLineText')}
          {listItem('AudiencePage.engageSecondLineTitle', 'AudiencePage.engageSecondLineText')}
          {listItem('AudiencePage.engageThirdLineTitle', 'AudiencePage.engageThirdLineText')}
          {listItem('AudiencePage.engageForthLineTitle', 'AudiencePage.engageForthLineText')}
        </ul>
      </div>
    </div>
  );
};

export default SectionEngage;
